<template>
	<div ref="idPan" style="height:100%; position:relative;">
		<div ref="idPhoto" style="position:absolute; left:200px; top:100px; width:400px; height:600px; background:#ffffff; border:2px solid #cccccc; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); display:none;" @mouseout="onMouseOut">
			<div style="float:left; width:400px; height:400px;">
				<img style="float:left; width: 100%; height: 100%; object-fit: contain; object-position: center;" :src="curPhoto">
			</div>
			<div ref="idQrCode" style="float:left; width:150px; height:150px; margin-left:125px; margin-top:25px;"></div>
		</div>

		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('日期')}}</div>
				<input type="text" style="width:120px;" maxlength=30 v-model="findPhotoDay" placeholder="YYYYMMDD">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; width:12px; text-indent:0px; padding-left:4px; border:0px;">-</div>
				<input type="text" style="width:120px;" maxlength=30 v-model="findPhotoDay2" placeholder="YYYYMMDD">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('照片编码')}}</div>
				<input type="text" style="width:260px;" maxlength=30 v-model="findOrderNo">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('设备编码')}}</div>
				<input type="text" style="width:220px;" maxlength=30 v-model="hdCode">

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>

	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'
import cselect    from '../cf/cselect'
import cpage      from '../cf/cpage'

export default {
	name: 'photoList',
	components:{
		ctable, popwin, cselect, cpage
	},
	data () {
		return {
			keyFind: 1000,
			findPhotoDay: "",                       // 拍照日期
			findPhotoDay2: "",                      // 拍照日期
			findOrderNo: "",                        // 照片ID
			hdCode: "",
			curPhoto: "",
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[this.getLangText('共'),this.getLangText('条记录,'),this.getLangText('页'),this.getLangText('条/页'),this.getLangText('页码'),'Go'],
				qryFunc: this.onListClick,      //查询回调函数
			},

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 440,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				rcallFunc: null,
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				lastSum: true,
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:this.getLangText("硬件编码"), width:300 },
					],
					head2:[                         // 数据列表头
						{ width:120, capt:this.getLangText('拍照日期') },
						{ width:260, capt:this.getLangText('照片编码') },
						{ width:160, capt:this.getLangText('打印张数') },
						{ width:160, capt:this.getLangText('AI次数') },
						{ width:160, capt:this.getLangText('分享途径') },
						{ width:200, capt:this.getLangText('添加时间') },
						{ width:200, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:220 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.findPhotoDay = this.getDateInt(0);
		this.findPhotoDay2 = this.getDateInt(0);

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

		this.ctrlTable.self.show();

		this.onListClick();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

			this.childResize( this );
		},
		/* 查询按钮事件响应 */
		onListClick: function(){
			if( this.findPhotoDay=="" || this.findPhotoDay2=="" )
			{
				this.appRoot.app.showDlgTip( 1200, LangText("请选择查询日期"), this.CLR.Err );
				return;
			}

			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1,
						cpDate: this.findPhotoDay,
						cpEDate: this.findPhotoDay2,
						cpOrderno: this.findOrderNo,
						cpDeviceId: this.login.custId,
						devHdcode: this.hdCode
					};

			this.doTrade( "POST", ServAddr+"/api/rec/photoRecQry", this.onListOK, true, body, null );
		},
		onListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			let pages=0;
			let aitimes=0;
			for(let i=0; i<data.body.list.length; i++ )
			{
				let item=data.body.list[i];
				this.ctrlTable.datas.data1.push([ item.devHdcode ]);

				this.ctrlTable.datas.data2.push( [ this.splitYMD(item.cpDate, 1) , item.cpOrderno,
							item.cpPrnTimes, item.cpAiUseTimes, item.cpShareMode,
							item.cpAddDatetime.substring(0,19), '' ] );
				pages = pages + item.cpPrnTimes;
				aitimes = aitimes + item.cpAiUseTimes;

				let op2={capt: this.getLangText("照片"), clk:null, param:item};
				if( item.cpPath!="" ) op2.clk = this.onPhotoClick;

				let op1={capt: "", clk:null, param:item};
				if( 0 < item.cpAiUseTimes )
				{
					if( item.cpLocalOrderno!="" )
						 op1 = {capt: this.getLangText("AI明细"), clk:this.onDetClick, param:item};
					else op1 = {capt: this.getLangText("AI明细"), clk:null, param:item};
					this.ctrlTable.datas.data3.push([ [ op2, op1 ] ]);
				}
				else
				{
					this.ctrlTable.datas.data3.push([ [ op2, op1 ] ]);
				}
			}
			this.ctrlTable.datas.data1.push([ this.getLangText('汇总') ]);
			this.ctrlTable.datas.data2.push( [ "-" , "-",
							"<font style='color:red;'>"+pages+"</font>",
							"<font style='color:red;'>"+aitimes+"</font>", "-", "-", "-" ] );
			this.ctrlTable.datas.data3.push([ "" ]);

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
		},
		onDetClick: function( param ){
			this.ctrlWin.w2 = 760;
			this.ctrlWin.h2 = 600;
			this.ctrlWin.captCont = LangText("AI明细");
			this.ctrlWin.vuepath = "/FrameBody/photoList/aiDetail";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		onPhotoClick: function( param ){
			if( this.$refs["idPhoto"].style["display"] == "block" )
				 this.$refs["idPhoto"].style["display"] = "none";
			else
			{
				this.$refs["idPhoto"].style["left"] = (window.innerWidth-400-200)/2+"px";
				this.$refs["idPhoto"].style["top"] = (window.innerHieght-400-50)/2+"px";
				this.$refs["idPhoto"].style["display"] = "block";
				this.curPhoto = param.cpPath.split(",")[0];

				this.$refs["idQrCode"].innerHTML = "";
				let curQrCode = new QRCode( this.$refs["idQrCode"], {width:150, height:150, text:""} );
				curQrCode.clear();
				curQrCode.makeCode( ServDom+"/static/phdown.html?orderno="+param.cpOrderno);
			}
		},
		onMouseOut: function(){
			this.$refs["idPhoto"].style["display"] = "none";
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// photoList.vue?f55a546a